module.exports = __webpack_public_path__ + "media/elevator_door.dd557a74.mp3";